module.exports = __webpack_public_path__ + "img/ios_step2.33cee9f9.png";